import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import {DEFAULT_PRICING_STRATEGY, PricingStrategy} from '@dms/api/shared';

import {SourcingType, useSourcingType} from './useSourcingType';

/**
 * Effective pricing strategy for the current sourcing type.
 *
 * TODO(T20-137991): Temporary – LFPP is not calculated for auctions yet, so auctions always use
 * FAIR_PRICE regardless of the persisted user setting. Remove the override once LFPP is available
 * for auctions.
 */
export function useSourcingPricingStrategy(): PricingStrategy {
  const {data} = useGetCurrentUserInfoQuery();
  const sourcingType = useSourcingType();

  if (sourcingType === SourcingType.AUCTIONS) {
    return PricingStrategy.FAIR_PRICE;
  }

  return data?.settings.pricingStrategy ?? DEFAULT_PRICING_STRATEGY;
}
